import { useHistory, useParams } from "react-router-dom";

import MeetingsOverviewSidebar from "@apps/meetings/sidebar";
import Sidebar from "@components/sidebar/sidebar";

const MeetingSidebar = () => {
  const { meetingId } = useParams<{
    meetingGroupId: string;
    meetingId: string;
  }>();
  const history = useHistory();

  const handleClose = () => {
    history.goBack();
  };

  return (
    <Sidebar onClose={handleClose}>
      <MeetingsOverviewSidebar hideMeetingBot meetingId={parseInt(meetingId)} />
    </Sidebar>
  );
};

export default MeetingSidebar;
